import React from 'react';

export const CircularProgressLocal = ({
  size = 120,
  strokeWidth = 12,
  progress = 65,
  trackColor = '#e5e7eb',
  progressColor = '#22c55e',
  bgColor = 'transparent',
  children,
}) => {
  const clamped = Math.max(0, Math.min(100, progress));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - clamped / 100);

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* optional background */}
      <circle cx={size / 2} cy={size / 2} r={size / 2} fill={bgColor} />

      {/* track */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill='none'
        stroke={trackColor}
        strokeWidth={strokeWidth}
      />

      {/* progress */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill='none'
        stroke={progressColor}
        strokeWidth={strokeWidth}
        strokeLinecap='butt'
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset 0.35s ease' }}
      />

      {/* children centered in the middle */}
      {children && (
        <foreignObject
          x={strokeWidth}
          y={strokeWidth}
          width={size - strokeWidth * 2}
          height={size - strokeWidth * 2}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              overflow: 'hidden',
            }}
          >
            {children}
          </div>
        </foreignObject>
      )}
    </svg>
  );
};
